import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import styles from 'components/Events/Events.module.sass'

const EventThumbnail = ({ thumbnail, title }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(true)

  useEffect(() => {
    const img = new Image()
    img.src = thumbnail
    img.onload = () => setIsImageLoaded(true)
    img.onerror = () => setIsImageLoaded(false)
  }, [thumbnail])

  return (
    <>
      {isImageLoaded && (
        <div
          role="img"
          aria-label={title}
          style={{ backgroundImage: `url(${thumbnail})` }}
          alt={title}
          className={styles.thumbnail}
        />
      )}
    </>
  )
}

EventThumbnail.propTypes = {
  title: PropTypes.string,
  thumbnail: PropTypes.string
}

export default EventThumbnail
